import { cloudFunction } from '../../config/firebaseConfig';

export const helpRequest = (helpData) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "HEPI_CALL_INIT",
            hepiMessage: "Sending your query...",
            showHepiLoader: true,
            hepiid: 0,
        });

        cloudFunction.httpsCallable('helpRequests-helpRequest')(
            {
                helpData,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "HEPI_CALL_COMPLETED",
                    hepiMessage: res.data.responseMsg,
                    showHepiLoader: false,
                    hepiid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "HEPI_CALL_ERROR",
                    hepiMessage: error.message,
                    showHepiLoader: false,
                    hepiid: -1,
                });
            });
    }
}